import { FC } from 'react';
import { Navigate } from 'react-router';

import { TRoleProtectedRouteProps } from './types.ts';

import { useProfileContext } from '@/contexts/profile';
import { ROUTES_TO_ROLES_RELATION_MAP } from '@/services/roles/constants.ts';
import { EAdminRoutes } from '@/services/router/enums.ts';

export const RoleProtectedRoute: FC<TRoleProtectedRouteProps> = ({ path, children }) => {
    const { role, loading } = useProfileContext();

    if (!loading) {
        const routeAllowedRoles = ROUTES_TO_ROLES_RELATION_MAP.get(path);
        const hasAccess = role && routeAllowedRoles?.includes(role);
        if (!routeAllowedRoles || !role || !hasAccess) {
            return <Navigate to={EAdminRoutes.NotFoundException} />;
        }
    }

    return children;
};
